import { render } from "./AppProductsPage.vue?vue&type=template&id=6b4421a6&ts=true"
import script from "./AppProductsPage.vue?vue&type=script&lang=ts"
export * from "./AppProductsPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__